import "./App.css";
import { Bg } from "@/components";
import { DragEventHandler, useEffect, useRef } from "react";
import { useCommonStore, useUserStore } from "./stores";
import {
  getSafariInfo,
  loadAdsJs,
  myBrowserOS,
} from "./utils";
import { ToastContainer, Bounce } from "react-toastify";
import { useIsMobile } from "@/hooks";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import Header from "./components/header";
import Analyse from "./utils/analyse";
import loadable from "@loadable/component";
import MobileMainSkeleton from "./components/MobileMain/MobileMainSkeleton";
import PCMainSkeleton from "./components/PCComponent/PCMain_skelton";
import useEffectStore from "./stores/effectStore";
import { I18nLangMap, SCENE_ID } from "./constants";
const MainActionFigure = loadable(
  () =>
    import(
      /* webpackChunkName: "p_main" */
      "./components/main-action-figure"
    ),
  {
    fallback: <PCMainSkeleton />,
  }
);
const MobileMainActionFigure = loadable(
  () =>
    import(
      /* webpackChunkName: "m_main" */
      "./components/mobile-main-action-figure"
    ),
  {
    fallback: <MobileMainSkeleton />,
  }
);

const App = () => {
  const { i18n } = useTranslation();
  const isMobile = useIsMobile();
  console.log("isMobile", isMobile);
  const adLoaded = useUserStore((state) => state.adLoaded);
  const userInfo = useUserStore((state) => state.userInfo);
  const isVip = useUserStore((state) => state.isVip);
  const isSvip = useUserStore((state) => state.isSvip);
  const generating = useEffectStore((state) => state.generating);
  const setAdLoaded = useUserStore((state) => state.setAdLoaded);
  const setIsMobile = useUserStore((state) => state.setIsMobile);
  const fetchCredits = useUserStore((state) => state.fetchCredits);
  const fetchUserInfo = useUserStore((state) => state.fetchUserInfo);
  const fetchVipStatus = useUserStore((state) => state.fetchVipStatus);
  const preApplyPresetTemp = useEffectStore(
    (state) => state.preApplyPresetTemp
  );
  const afterApplyPresetTemp = useEffectStore(
    (state) => state.afterApplyPresetTemp
  );
  const setSafariInfo = useUserStore((state) => state.setSafariInfo);
  const showPayment = useUserStore((state) => state.showPayment);
  const receiveCredits = useUserStore((state) => state.receiveCredits);
  const setIsDrag = useCommonStore((state) => state.setIsDrag);
  const getEffectList = useEffectStore((state) => state.getEffectList);
  const getLableList = useEffectStore((state) => state.getLableList);
  const refreshLang = useEffectStore(state=>state.refreshI18n)

  const handleDragEnter: DragEventHandler<HTMLDivElement> = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!generating) {
      setIsDrag(true);
    }
  };

  useEffect(() => {
    (async () => {
      preApplyPresetTemp();
      await getLableList();
      await getEffectList();
      // applyPresetTemp();
      afterApplyPresetTemp();
      Analyse.getInstance().enterPage();
    })();
  }, []);

  useEffect(() => {
    setIsMobile(isMobile || false);
  }, [isMobile]);

  useEffect(() => {
    (async () => {
      await fetchUserInfo();
      await receiveCredits();
      await fetchVipStatus();
      await fetchCredits();
      const isLogin = useUserStore.getState().getters.isLogin;
      if (!isLogin) {
        useUserStore.getState().refreshFreeCount();
      }
    })();
  }, []);

  // 埋点（进入工具）

  useEffect(() => {
    setSafariInfo(getSafariInfo());
  }, []);

  useEffect(() => {
    const listener = () => {
      // languageChanged 事件在语言改变前就执行了，这里给个延迟，让其在改变后执行
      setTimeout(() => {
        refreshLang(I18nLangMap[i18n.language]);
      }, 500);
    };

    i18n.on("languageChanged", listener);

    return () => {
      i18n.off("languageChanged", listener);
    };
  }, []);

  // 加载广告
  useEffect(() => {
    if (navigator.userAgent !== "ReactSnap") {
      const { iPad } = myBrowserOS();
      if (!isMobile && !iPad) {
        loadAdsJs().then(() => {
          window.adpopup?.fillAds(
            [{ eleId: "banner_ad", type: "top" }],
            (el: any) => {
              if (el.type === "close" && el.adData.type === "top") {
                setAdLoaded(false);
              }
              if (
                el.haveAd &&
                el.adDomId === "banner_ad" &&
                el.type === "loaded"
              ) {
                setAdLoaded(true);
              }

              if (el.type === "confirm" && el.action === false) {
                if (
                  el.adData.jumpUrl === "upgrade" ||
                  el.adData.jumpUrl === "upgradesvip"
                ) {
                  if (userInfo) {
                    let promotionId =
                      el.adData.promotionId &&
                      el.adData.promotionId !== null &&
                      el.adData.promotionId.length > 0
                        ? el.adData.promotionId[0]
                        : "";

                    showPayment({
                      position: "figure_generate",
                      otherParam: {
                        scenesId: SCENE_ID,
                        promotionId: promotionId ? promotionId : "",
                      },
                      callback: () => {
                        fetchCredits();
                      },
                      payType: isVip || isSvip ? "credit_sub" : "other",
                    });
                  }
                } else {
                  window.open(el.adData.jumpUrl, "__blanck");
                }
              } else if (el.type === "confirm") {
                window.open(el.adData.jumpUrl);
              }
            }
          );
        });
      }
    }
  }, []);

  useEffect(() => {
    const visibilitychange = async () => {
      if (document.visibilityState === "visible") {
        await receiveCredits();
        await fetchCredits();
      }
    };
    document.addEventListener("visibilitychange", visibilitychange);

    return () => {
      document.removeEventListener("visibilitychange", visibilitychange);
    };
  }, []);

  return (
    <div className="app" id="app" onDragEnter={handleDragEnter}>
      {!isMobile && <Bg></Bg>}

      <div id="banner_ad" className={clsx(adLoaded && "top_ad")}></div>

      <Header />
      {!isMobile && <MainActionFigure></MainActionFigure>}
      {/* <PCMain/> */}
      {isMobile && <MobileMainActionFigure></MobileMainActionFigure>}
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Bounce}
        closeButton={false}
        limit={3}
        className="custom_toast_container"
        toastClassName="custom_toast"
        bodyClassName="custom_toast_body"
      />
    </div>
  );
};

export default App;
